module.exports = __webpack_public_path__ + "static/16-b4881a7dcd4e9de2e4bdb71933be42a2.png";